module.exports = __webpack_public_path__ + "static/media/broker.257dd02a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/broker.png
// module id = 737
// module chunks = 0 1